import { createContext, useState } from "react";

export const ModalContext = createContext();

export const ModalContextProvider = ( { children } ) => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
	const [isEventModalOpen, setIsEventModalOpen] = useState(false)

	return (
		<ModalContext.Provider value={ { isModalOpen, setIsModalOpen, isInfoModalOpen, setIsInfoModalOpen, isEventModalOpen, setIsEventModalOpen } }>
			{children}
		</ModalContext.Provider>
	)
};